import {
  extractData,
  extractDataWithMeta,
} from "@shared/utils/extract-dto-data";
import { safeParseWithFallback } from "@shared/utils/safe-parse-with-fallback";

import { ShopDataSchema, ShopItemsDtoSchema, ShopPageSchema } from "./schemas";
import type { PageType, ShopDataType, ShopListType } from "./types";

const defaultMeta = {
  pagination: { page: 1, pageSize: 0, pageCount: 0, total: 0 },
};

export const mapDtoToShopItems = (dto: unknown): ShopListType => {
  const parsed = safeParseWithFallback(
    ShopItemsDtoSchema,
    dto,
    "mapDtoToShopItems",
  );

  return extractDataWithMeta<ShopListType["data"], ShopListType["meta"]>(
    parsed,
    dto,
    defaultMeta as ShopListType["meta"],
  );
};

export const mapDtoToShopPage = (dto: unknown): PageType => {
  const parsed = safeParseWithFallback(ShopPageSchema, dto, "mapDtoToShopPage");

  return extractData(parsed, dto, dto as PageType);
};

export const mapDtoToSizeTable = (dto: unknown): ShopDataType => {
  const parsed = safeParseWithFallback(
    ShopDataSchema,
    dto,
    "mapDtoToSizeTable",
  );

  return extractData(parsed, dto, dto as ShopDataType);
};
